import * as React from 'react'
import { connect } from 'react-redux'
import {Container, Card, CardImg, CardBody, Row, CardHeader, Col, Button} from "reactstrap";
import {WithTranslation, withTranslation} from "react-i18next";
import {
    ConfiguratorProductAlternativeused
} from "App/services/api";
import {extractPrice} from "App/services";
import {BASE_URL, CurrencyProps, gtm, GTM_USED, Language, LinkType, URL_USED_MACHINES} from "App/constants";
import ImageGallery from "react-image-gallery";
import {Element} from "react-scroll/modules";
import {selectedLang} from "App/helper";

interface StateToProps extends CurrencyProps {
    alternativeused: Array<ConfiguratorProductAlternativeused>
}

interface DispatchToProps {
    onShowAllUsed: () => void
    onOpenDataSheet: (url: string | undefined) => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onShowAllUsed: () => {
        window.open(URL_USED_MACHINES, '_blank')
    },
    onOpenDataSheet: (url: string) => {
        window.open(BASE_URL + url, '_blank');
        gtm(GTM_USED);
    }
});

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation> {
    render() {
        const {i18n, currency, alternativeused,
            t, onOpenDataSheet, onShowAllUsed} = this.props;
        const language: Language = selectedLang(i18n);
        return <Element name={LinkType.USED_SECTION}>
            <Card className="mt-6 d-print-none">
                <CardHeader className="px-5 py-3 d-flex align-items-center conf-title">
                    <span className="m-0 w-75 pt-2 float-left title-normal-uppercase">{t('products.configuration.usedtitle')}</span>
                </CardHeader>
            </Card>
            <Container className="px-0 pt-2 d-print-none">
                <Row className="">
                    {
                        alternativeused.map((alternative: ConfiguratorProductAlternativeused, index: number) => {
                            const price: number|null = extractPrice(alternative.price, currency);

                            const additionalImages = alternative.extraimages&&alternative.extraimages.length?alternative.extraimages.map((image: string, index: number) => {
                                return {
                                    original: image
                                };
                            }):null;

                            const images = additionalImages&&alternative.usedequipmentfrontleftimageurl?[
                            {
                                    original: alternative.usedequipmentfrontleftimageurl
                            }
                            ].concat(additionalImages):null;

                            return <div className="col-sm-6 py-2" key={alternative.usedequipmentid}>
                                <Card className="">
                                    <CardBody className="bodyslice">
                                        <div className="title-small-uppercase">{alternative.brand}</div>
                                        <div className="title-large-uppercase pb-2">{alternative.type}</div>
                                        <div className="card-image-container">
                                            {images?
                                                <ImageGallery items={images} lazyLoad={true} showThumbnails={false} useBrowserFullscreen={false} showPlayButton={false}/>:
                                                <CardImg src={alternative.usedequipmentfrontleftimageurl}
                                                         className="p-0 img-fluid mx-auto d-block"/>
                                            }
                                        </div>
                                        <Row className="pt-2 no-gutters">
                                            <Col className="col-md-6 pb-3">
                                                <div className="title-small-uppercase">{ t('products.configuration.usedprice') }</div>
                                                <div className="text-bigger-details">{ price?t('products.configuration.price', {amount:price, unit:currency}):t('products.configuration.priceonrequest') }</div>
                                            </Col>
                                            <Col className="action col-md-6" onClick={()=>onOpenDataSheet(alternative.usedequipmentpdfdatasheeturl[language])}>
                                                <div className="title-small-uppercase text-action-document">{ t('products.configuration.useddatasheet') }</div>
                                                <i className="far fa-file-pdf fa-lg iconline"></i>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </div>}
                        )
                    }
                </Row>
                <Row className="no-gutters mt-2">
                    <Col>
                        <Button className="advice w-100 text-uppercase text-left" onClick={()=>onShowAllUsed()}>
                            <i className="far fa-arrow-circle-right pr-2 fa-lg"></i>{ t('products.configuration.showallused') }
                        </Button>
                    </Col>
                </Row>
            </Container>
        </Element>
    }
}

export const Component = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/AlternativeUsed.tsx